import { render, staticRenderFns } from "./CitationFooter.vue?vue&type=template&id=616d4e92&scoped=true&"
import script from "./CitationFooter.vue?vue&type=script&lang=js&"
export * from "./CitationFooter.vue?vue&type=script&lang=js&"
import style0 from "./CitationFooter.vue?vue&type=style&index=0&id=616d4e92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616d4e92",
  null
  
)

export default component.exports